export enum SignalType {
  GROWTH = "GROWTH",
  RISK = "RISK",
}

export enum SignalTypeLabel {
  GROWTH = "Growth",
  RISK = "Risk",
}

export enum SignalStatus {
  OPEN = "OPEN",
  CLOSED = "CLOSED",
}

export enum SignalStatusLabel {
  OPEN = "Open",
  CLOSED = "Closed",
}
